import {
  Box,
  Divider,
  Flex,
  Heading,
  HStack,
  Icon,
  Image,
  Text,
  VStack,
  Stack,
} from "@chakra-ui/react";
import {
  FaEnvelope,
  FaFacebook,
  FaLocationArrow,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";
import GoogleRating from "./GoogleRating";

const Header = () => {
  return (
    <Box bg="black" color="white" py={3} px={6}>
      <Flex
        justify="space-between"
        align="center"
        flexDirection={{ base: "column", md: "row" }} // Stack on mobile, row on larger screens
        textAlign={{ base: "center", md: "left" }} // Center text for mobile
        gap={{ base: 4, md: 0 }} // Add spacing for mobile
      >
        {/* Logo & Title */}
        <Flex
          gap={{ base: 0, md: 4 }}
          align="center"
          flexDirection={{ base: "column", md: "row" }}
        >
          <Image
            src="/images/logo1.png"
            alt="Logo"
            boxSize={{ base: "60px", md: "75px" }} // Smaller logo for mobile
            mb={{ base: 2, md: 0 }} // Margin for spacing in mobile view
          />
          <VStack align={{ base: "center", md: "start" }} gap={0}>
            <Heading size={{ base: "md", md: "lg" }}>FIXED AND FITTED</Heading>
            <Text fontSize={{ base: "xs", md: "sm" }} color={"gray.200"}>
              Front gate to the door, ceiling to the floor, your handyman needs
              will need no more
            </Text>
          </VStack>
        </Flex>

        {/* Contact Details */}
        <Stack
          direction={{ base: "column", sm: "row", md: "row" }}
          align={{ base: "center", md: "center" }}
          justifyContent={{ base: "end", sm: "center", md: "end" }}
          spacing={{ base: 3, md: 5 }}
          width="100%"
        >
          <GoogleRating />

          <VStack
            align={{ base: "center", sm: "start", md: "start" }}
            spacing={2}
          >
            <Stack
              align={{ base: "center", md: "start" }}
              direction={{ base: "row", md: "column" }}
            >
              <HStack
                spacing={2}
                as="a"
                href="mailto:sw@fixedandfitted.info"
                align="center"
              >
                <Icon as={FaEnvelope} boxSize={5} />
                <Text
                  fontSize={{ base: "2xs", md: "sm" }}
                  color="white.200"
                  textDecor={"underline"}
                >
                  sw@fixedandfitted.info
                </Text>
              </HStack>

              <HStack
                as="a"
                href="https://wa.me/447845255246"
                target="_blank"
                rel="noopener noreferrer"
                align="center"
                spacing={1}
              >
                <Icon as={FaWhatsapp} boxSize={6} />
                <Text
                  fontSize={{ base: "2xs", md: "sm" }}
                  // color="green.200"
                  textDecor={"underline"}
                >
                  07845 255 246
                </Text>
              </HStack>
            </Stack>
            <Stack
              align={{ base: "center", md: "start" }}
              direction={{ base: "row", md: "column" }}
            >
              <HStack
                spacing={2}
                as="a"
                href="https://www.facebook.com/share/1BJ8sp5aRq/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon as={FaFacebook} boxSize={5} />
                <Text
                  fontSize={{ base: "2xs", md: "sm" }}
                  // color="blue.200"
                  textDecor={"underline"}
                >
                  Swfixed Andfitted
                </Text>
              </HStack>

              {/* <HStack spacing={1}>
                <Icon as={FaLocationArrow} boxSize={5} />
                <Text fontSize={{ base: "2xs", md: "sm" }}>
                  {" "}
                  Cannock & surrounding areas
                </Text>
              </HStack> */}
            </Stack>
          </VStack>
        </Stack>
      </Flex>
    </Box>
  );
};

export default Header;
